/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CashExposureType } from './CashExposureType';
import {
    CashExposureTypeFromJSON,
    CashExposureTypeFromJSONTyped,
    CashExposureTypeToJSON,
} from './CashExposureType';
import type { ConvictionAllocationType } from './ConvictionAllocationType';
import {
    ConvictionAllocationTypeFromJSON,
    ConvictionAllocationTypeFromJSONTyped,
    ConvictionAllocationTypeToJSON,
} from './ConvictionAllocationType';
import type { GrowthAllocationType } from './GrowthAllocationType';
import {
    GrowthAllocationTypeFromJSON,
    GrowthAllocationTypeFromJSONTyped,
    GrowthAllocationTypeToJSON,
} from './GrowthAllocationType';
import type { SecuredAllocationType } from './SecuredAllocationType';
import {
    SecuredAllocationTypeFromJSON,
    SecuredAllocationTypeFromJSONTyped,
    SecuredAllocationTypeToJSON,
} from './SecuredAllocationType';
import type { UnmanagedAllocationType } from './UnmanagedAllocationType';
import {
    UnmanagedAllocationTypeFromJSON,
    UnmanagedAllocationTypeFromJSONTyped,
    UnmanagedAllocationTypeToJSON,
} from './UnmanagedAllocationType';

/**
 * 
 * @export
 * @interface AllocationType
 */
export interface AllocationType {
}

/**
 * Check if a given object implements the AllocationType interface.
 */
export function instanceOfAllocationType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AllocationTypeFromJSON(json: any): AllocationType {
    return AllocationTypeFromJSONTyped(json, false);
}

export function AllocationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllocationType {
    return json;
}

export function AllocationTypeToJSON(value?: AllocationType | null): any {
    return value;
}

